export class CURP {
  public static regex =
    /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

  static charValues = {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    Ñ: 24,
    O: 25,
    P: 26,
    Q: 27,
    R: 28,
    S: 29,
    T: 30,
    U: 31,
    V: 32,
    W: 33,
    X: 34,
    Y: 35,
    Z: 36,
  };

  public static validate(curp: string): boolean {
    return (curp.match(this.regex) || []).length > 0;
  }

  public static validateLastDigit(curp: string): boolean {
    let summatory = 0;
    for (let i = 0; i < curp.length - 1; i++) {
      summatory += (curp.length - i) * this.charValues[curp[i]];
    }
    summatory = summatory % 10;
    summatory = summatory > 0 ? 10 - summatory : summatory;

    return parseInt(curp[17]) == summatory;
  }

  public static extractBirthdateFromCURP(curp: string): Date {
    let year = parseInt(curp.slice(4, 6), 10);
    const month = parseInt(curp.slice(6, 8), 10) - 1;
    const day = parseInt(curp.slice(8, 10), 10);
    year += year < 20 ? 2000 : 1900;
    return new Date(year, month, day);
  }

  public static ageFromCURP(curp: string) {
    if (curp) {
      const birthdate = this.extractBirthdateFromCURP(curp);
      const today = new Date();

      let age = today.getFullYear() - birthdate.getFullYear();
      const monthDiff = today.getMonth() - birthdate.getMonth();
      const dayDiff = today.getDate() - birthdate.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age -= 1;
      }
      return age;
    } else {
      return "";
    }
  }

  public static isForeigner(curp: string): boolean {
    const FOREIGNER_CURP_SUFFIX = "NE";
    return String(curp ?? "").toUpperCase().slice(11, 13) === FOREIGNER_CURP_SUFFIX;
  }

  public static nationalityFromCURP(curp: string | null | undefined): string | null {
    const normalized = String(curp ?? "").trim().toUpperCase();
    if (!normalized) return null;
    return this.isForeigner(normalized) ? "Extranjera" : "Mexicana";
  }
}
